import {Injectable} from '@angular/core';
import {AbstractModelService} from '../model/abstract-model.service';
import {ApiClientService} from '../api-client/api-client.service';
import {PartnerContact} from '../../models/partner-contact';

@Injectable({
  providedIn: 'root'
})
export class PartnerContactService extends AbstractModelService<PartnerContact> {

  constructor(apiClient: ApiClientService) {
    super(apiClient, '/partner-contact', PartnerContact);
  }
}
